import { TranslationKey } from './../../../../../types/translation/TranslationKey';
import React, { useContext, useState, useMemo } from 'react';
import { FilterProps } from '../../common/filter.util';
import { Divider, Grid } from '@mui/material';
import { DeleteIcon } from '../../../../icons/Delete/DeleteIcon';
import { VentoryColor } from '../../../../util/color.util';
import { t } from '../../../../../types/translation/Translator';
import MultiSelectionList from '../../../common/MultiSelectionList/MultiSelectionList';
import SearchBar from '../../../common/SearchBar/SearchBar';
import { LotContext } from '../../../../../context/LotContext';
import { ProductMasterDataContext } from '../../../../../context/ProductMasterDataContext';
import { LotFilter } from '../LotFilter';

interface LotFilterContentProps {
  filter: LotFilter;
  filterProps: FilterProps;
  setFilterProps: (filter: FilterProps) => void;
}

export default function LotFilterContent({ filter, filterProps, setFilterProps }: LotFilterContentProps) {
  const { lots } = useContext(LotContext);
  const { productMasterData } = useContext(ProductMasterDataContext);

  const [textFilter, setTextFilter] = useState<string>('');

  const values = useMemo(() => {
    const items = new Set<string>();
    for (const lot of lots.values()) {
      if (!filter.search(lot, textFilter)) continue;
      if (filterProps.company?.size && !filterProps.company.has(lot.companyId)) continue;
      items.add(lot.id);
    }
    return items;
  }, [textFilter, lots, filter, filterProps.company]);

  const handleChange = (selected: Set<string>) => {
    filterProps.lot = selected;
    setFilterProps({ ...filterProps });
  };

  const handleRemove = () => {
    filterProps.lot = undefined;
    setFilterProps({ ...filterProps });
  };

  return (
    <Grid item xs={12} className='w-full'>
      <Grid container>
        <Grid item xs={12} className='flex px-3 py-2'>
          <Grid container>
            <Grid item>
              <p className='text-ventory-grey-500 text-[13px] font-[500]'>{t(TranslationKey.lot).singular.label}</p>
            </Grid>
            <Grid item flexGrow={1} display={'flex'} justifyContent={'flex-end'} sx={{ color: VentoryColor.deleteRed }}>
              <Grid item onClick={handleRemove} className='cursor-pointer'>
                <DeleteIcon />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <SearchBar onChange={i => setTextFilter(i)} className='pl-3 pr-4' />
        </Grid>
        <Grid item className='py-3' xs={12}>
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <MultiSelectionList
            selected={filterProps.lot}
            values={values}
            onChange={handleChange}
            toText={id => `${lots.get(id)?.number}`}
            toSubText={id => `${productMasterData.get(lots.get(id)?.productMasterDataId || '')?.productName || ''}`}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}
